// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"33cb83dc","124":"de08e583","300":"de08e583","366":"3b4c2b81","544":"d95dda4f","802":"3b4c2b81","965":"b7dc1ed8"}[chunkId] + ".chunk.css";
};